import React from 'react';

import AbbyChatIcon from 'src/components/icons/abby-chat-icon';
import abby, { ABBY_CHAT_ICON_ID } from 'src/helpers/abby';

import * as styles from './abby-chat-icon.module.scss';

const AbbyChatBotIcon: React.FC = () => {
  return (
    <button
      id={ABBY_CHAT_ICON_ID}
      type="button"
      className={styles.icon}
      onClick={abby.open}
      aria-label="Open abby chat"
      data-abby-chat-icon="true"
    >
      <AbbyChatIcon fill="#FFF" size={25} />
    </button>
  );
};

export { AbbyChatBotIcon };
